// ======================================================================
// StockRegisterPage.jsx
// PPE → Inventory → Reports → Stock Register
// ======================================================================

import React, { useState } from "react";

import SearchableDropdown from "../../../../components/common/SearchableDropdown";
import warehouseLookupService from "./warehouseLookupService";
import materialLookupService from "./materialLookupService";

//import { fetchStockRegister } from "./stockRegisterService";
import {
  fetchStockRegister,
  exportStockRegisterExcel
} from "./stockRegisterService";

import ERPReportLayout from
"../../../../components/reports/ERPReportLayout";

import ERPFilterBar from
"../../../../components/reports/ERPFilterBar";

import ERPDataGrid from
"../../../../components/reports/ERPDataGrid";

import ERPReportActions from
"../../../../components/reports/ERPReportActions";

import "../../../../components/reports/reportStyles.css";

export default function StockRegisterPage() {

  const today = new Date().toISOString().slice(0, 10);

  const [filters, setFilters] = useState({
  fromDate: today,
  toDate: today,

  material: "",
  materialLabel: "",

  warehouse: "",
  warehouseLabel: "",

  batch: ""
});
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  // ------------------------------------------------
  // LOAD DATA
  // ------------------------------------------------
  const loadData = async () => {

  if (!filters.fromDate || !filters.toDate) {
    alert("From & To date required");
    return;
  }

  setLoading(true);
  try {

    const data = await fetchStockRegister(filters);

    console.log("FULL DATA", data);
    console.log("ROWS", data.rows);

    setRows(data.rows || []);
    setCurrentPage(1);


  } finally {
    setLoading(false);
  }
};

  // ------------------------------------------------
  // EXPORT HANDLER
  // ------------------------------------------------
  const handleExport = async (format) => {

  try {

    if (format !== "xlsx") {
      alert("PDF export not implemented yet");
      return;
    }

    const blob =
      await exportStockRegisterExcel(filters);

    const url =
      window.URL.createObjectURL(
        new Blob([blob])
      );

    const link =
      document.createElement("a");

    link.href = url;

    link.setAttribute(
      "download",
      "stock_register.xlsx"
    );

    document.body.appendChild(link);

    link.click();

    link.remove();

  } catch (err) {

    console.error(err);

    alert("Failed to export report");
  }
};

  const totalPages = Math.max(
  1,
  Math.ceil(rows.length / pageSize)
);

const paginatedRows = rows.slice(
  (currentPage - 1) * pageSize,
  currentPage * pageSize
);

const pageNumbers = Array.from(
  { length: totalPages },
  (_, i) => i + 1
).filter(
  page =>
    page >= currentPage - 2 &&
    page <= currentPage + 2
);

  // ------------------------------------------------
  // GRID COLUMN CONFIG (ERP STANDARD)
  // ------------------------------------------------
  const columns = [
    {
      key: "date",
      label: "Date",
      render: r => r.date?.slice(0, 10)
    },
    {
      key: "transaction_no",
      label: "Txn No",
      bold: true
    },
    {
      key: "transaction_type",
      label: "Type"
    },
    {
  key: "material_code",
  label: "Material Code"
},
{
  key: "material_name",
  label: "Material Name"
},

    {
  key: "warehouse_name",
  label: "Warehouse",
  render: r =>
    `${r.warehouse_code} - ${r.warehouse_name}`
},
    {
      key: "batch_no",
      label: "Batch",
      render: r => r.batch_no || "-"
    },
    {
  key: "uom_name",
  label: "UOM"
},
{
  key: "unit_rate",
  label: "Rate",
  align: "right",
  render: r => Number(r.unit_rate || 0).toFixed(2)
},
    {
      key: "qty_in",
      label: "Qty In",
      align: "right"
    },
    {
      key: "qty_out",
      label: "Qty Out",
      align: "right"
    },
    {
      key: "balance",
      label: "Balance",
      align: "right",
      bold: true
    },
    {
  key: "value",
  label: "Value",
  align: "right",
  render: r => Number(r.value || 0).toFixed(2)
},
  ];

  // ------------------------------------------------
  // FILTER BAR
  // ------------------------------------------------
  const filterBar = (
    <ERPFilterBar
      left={
        <>
          <input
            type="date"
            value={filters.fromDate}
            className="erp-filter"
            onChange={e =>
              setFilters(prev => ({
                ...prev,
                fromDate: e.target.value
              }))
            }
          />

          <input
            type="date"
            value={filters.toDate}
            className="erp-filter"
            onChange={e =>
              setFilters(prev => ({
                ...prev,
                toDate: e.target.value
              }))
            }
          />

          <SearchableDropdown
            label=""
            value={filters.materialLabel}
            placeholder="Search Material..."
            fetchOptions={materialLookupService.searchRawMaterial}
            getOptionLabel={(o) =>
              `${o.material_code} - ${o.material_name}`
            }
            onChange={(v) =>
              setFilters(prev => ({
                ...prev,
                material: v.id,
                materialLabel:
                  `${v.material_code} - ${v.material_name}`
              }))
            }
          />

          <SearchableDropdown
            label=""
            value={filters.warehouseLabel}
            placeholder="Search Warehouse..."
            fetchOptions={warehouseLookupService.search}
            getOptionLabel={(o) =>
              `${o.warehouse_code} - ${o.warehouse_name}`
            }
            onChange={(v) =>
              setFilters(prev => ({
                ...prev,
                warehouse: v.id,
                warehouseLabel:
                  `${v.warehouse_code} - ${v.warehouse_name}`
              }))
            }
          />

          <input
            placeholder="Batch"
            className="erp-filter"
            onChange={e =>
              setFilters(prev => ({
                ...prev,
                batch: e.target.value
              }))
            }
          />

          <button
            onClick={loadData}
            className="erp-primary-btn"
          >
            Load
          </button>
        </>
      }

      right={
        <div className="flex items-center gap-4">
          <ERPReportActions onExport={handleExport} />
        </div>
      }
    />
  );
  console.log("CURRENT ROWS STATE", rows);

  console.log("STOCK REGISTER NEW BUILD");
  // =====================================================
  // UI
  // =====================================================
  return (
    <ERPReportLayout
  title="Inventory — Stock Register"
  subtitle="Material movement history"
  toolbar={filterBar}
>
  <div>

    <ERPDataGrid
      columns={columns}
      rows={paginatedRows}
      loading={loading}
      height="600px"
    />

    
    <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">

  <div>
    Showing{" "}
    {(currentPage - 1) * pageSize + 1}
    {" - "}
    {Math.min(
      currentPage * pageSize,
      rows.length
    )}
    {" of "}
    {rows.length}
    {" records"}
  </div>

  <div className="d-flex align-items-center gap-2">

    <span>Rows:</span>

    <select
      className="form-select form-select-sm"
      style={{ width: "90px" }}
      value={pageSize}
      onChange={(e) => {
        setPageSize(Number(e.target.value));
        setCurrentPage(1);
      }}
    >
      <option value={20}>20</option>
      <option value={50}>50</option>
      <option value={100}>100</option>
    </select>

    <button
      className="btn btn-sm btn-outline-secondary"
      disabled={currentPage === 1}
      onClick={() => setCurrentPage(1)}
    >
      {"<<"}
    </button>

    <button
      className="btn btn-sm btn-outline-secondary"
      disabled={currentPage === 1}
      onClick={() =>
        setCurrentPage(currentPage - 1)
      }
    >
      {"<"}
    </button>

    {pageNumbers.map((page) => (
      <button
        key={page}
        className={
          page === currentPage
            ? "btn btn-sm btn-primary"
            : "btn btn-sm btn-outline-secondary"
        }
        onClick={() =>
          setCurrentPage(page)
        }
      >
        {page}
      </button>
    ))}

    <button
      className="btn btn-sm btn-outline-secondary"
      disabled={currentPage === totalPages}
      onClick={() =>
        setCurrentPage(currentPage + 1)
      }
    >
      {">"}
    </button>

    <button
      className="btn btn-sm btn-outline-secondary"
      disabled={currentPage === totalPages}
      onClick={() =>
        setCurrentPage(totalPages)
      }
    >
      {">>"}
    </button>

  </div>

</div>

  </div>
</ERPReportLayout>

  );
}
